module.exports = __webpack_public_path__ + "static/media/lead-benefit4.27770b16.png";